import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { tokens } from '../../../../global/theme/tokens';

export const MatchingPropLeadFieldCheckboxShow = ({ property }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { t } = useTranslation();
  const { publicLabel, minValue, unit, label } = property;

  const isChecked = Boolean(parseInt(minValue));

  const color = isChecked ? colors.success : colors.error;

  return (
    <Box className="flex items-items justify-between gap-2">
      <Typography>{`${publicLabel || label}: `}</Typography>
      <Typography
        sx={{
          bgcolor: color + '30',
          border: `1px solid ${color}80`,
          height: '20px',
        }}
        fontSize={12}
        className="rounded-md px-2 flex items-center"
      >
        {minValue === null ? (
          t('Yes/No')
        ) : isChecked ? (
          <>
            {t('Yes')}
            <CheckIcon
              color="success"
              className="ml-1"
              sx={{ fontSize: '18px' }}
            />
          </>
        ) : (
          <>
            {t('No')}{' '}
            <CloseIcon
              color="error"
              className="ml-1"
              sx={{ fontSize: '18px' }}
            />
          </>
        )}
      </Typography>
    </Box>
  );
};
